<template lang="pug">
b-input(
  ref="input"
  icon="cellphone"
  :placeholder="placeholder"
  :value="number"
  @input="update"
)
</template>

<script>
export default {
  name: 'phone-field',
  $_veeValidate: {
    value() {
      return this.number;
    },
  },
  created() {
    const params = Object.assign({}, { number: this.value });
    if (params.number) {
      const number = params.number.match(/\+1/) ? params.number : params.number.replace(/\D/g, '');
      this.number = this.$options.filters.phoneNumber(number);
    }
  },
  data() {
    return {
      number: null,
    };
  },
  methods: {
    update(val) {
      const formatted = val.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
      this.number = formatted;
      this.$emit('input', formatted);
    },
  },
  props: {
    placeholder: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/form/PhoneField.vue